// extracted by mini-css-extract-plugin
export default {"divSearch":"Search_divSearch__j1iSY"};